<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="dataToDiff && dataToDiff.equipment.name">
      {{ dataToDiff.equipment.name }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <disclaimer *ngIf="isViewMode" [message]="'APPROVALS_EQUIPMENTS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>

  <div class="field-dialog__content">
    <form
      class="field-dialog__content__scroll disabled-content p-24"
      [ngClass]="{ 'form-height': isExistingNumber }"
      fxLayout="column"
      name="form"
      fusePerfectScrollbar
    >
      <div>
        <div fxFlex="10" class="pl-4" style="align-self: flex-start">
          <img
            (error)="$event.target.src = 'https://ui-avatars.com/api/?name=' + dataToDiff.approval.company.name"
            [src]="dataToDiff.approval.company.avatarUrl"
            alt="company logo"
            class="company-logo"
          />
        </div>

        <mat-form-field appearance="legacy" fxFlex="40" class="pr-4">
          <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.COMPANY' | translate }}</mat-label>
          <input matInput [value]="dataToDiff.approval.company.name" disabled />
        </mat-form-field>

        <mat-form-field appearance="legacy" fxFlex="30" fxFlex.xs="100" class="pl-4 pr-4">
          <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVAL_CREATED_AT' | translate }}</mat-label>
          <input matInput [value]="dataToDiff.approval.createdAt | date: 'dd/MM/yyyy HH:mm'" disabled />
        </mat-form-field>

        <mat-form-field appearance="legacy" fxFlex="20" fxFlex.xs="100" class="pl-4">
          <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVAL_STATUS' | translate }}</mat-label>
          <input matInput [value]="dataToDiff.approval.approvalStatus" disabled />
        </mat-form-field>
      </div>

      <div>
        <!-- CURRENT EQUIPMENT -->
        <div fxFlex="50" class="pr-4" fxLayout="column" fxLayoutAlign="start start">
          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.location.name !== dataToDiff.approval.equipment.location.name"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.LOCATION' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.location.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="
              dataToDiff.equipment.location.address.formattedAddress !==
              dataToDiff.approval.equipment.location.address.formattedAddress
            "
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.ADDRESS' | translate }}</mat-label>
            <textarea
              matInput
              matTextareaAutosize
              matAutosizeMinRows="3"
              matAutosizeMaxRows="3"
              [value]="dataToDiff.equipment.location.address.formattedAddress"
              disabled
            ></textarea>
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.name !== dataToDiff.approval.equipment.name"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NAME' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.qrCode !== dataToDiff.approval.equipment.qrCode"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.QR_CODE' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.qrCode" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.number !== dataToDiff.approval.equipment.number"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NUMBER' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.number" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.type.name !== dataToDiff.approval.equipment.type.name"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.TYPE' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.type.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.archived !== dataToDiff.approval.equipment.archived"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_STATUS' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.archived" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="dataToDiff.equipment.notes !== dataToDiff.approval.equipment.notes"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.COMMENTS' | translate }}</mat-label>
            <textarea
              matInput
              matTextareaAutosize
              matAutosizeMinRows="3"
              matAutosizeMaxRows="3"
              [value]="dataToDiff.equipment.notes"
              disabled
            ></textarea>
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="
              dataToDiff.equipment.locationSector?.name !== dataToDiff.approval.equipment.locationSector?.name
            "
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_LOCATION_SECTOR' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.locationSector?.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-red]="
              dataToDiff.equipment.locationEnvironment?.name !== dataToDiff.approval.equipment.locationEnvironment?.name
            "
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_LOCATION_ENVIRONMENT' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.equipment.locationEnvironment?.name" disabled />
          </mat-form-field>
        </div>
        <!-- END CURRENT EQUIPMENT -->

        <!-- MODIFIED EQUIPMENT -->
        <div fxFlex="50" class="pl-4" fxLayout="column" fxLayoutAlign="start start">
          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.location.name !== dataToDiff.approval.equipment.location.name"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.LOCATION' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.location.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="
              dataToDiff.equipment.location.address.formattedAddress !==
              dataToDiff.approval.equipment.location.address.formattedAddress
            "
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.ADDRESS' | translate }}</mat-label>
            <textarea
              matInput
              matTextareaAutosize
              matAutosizeMinRows="3"
              matAutosizeMaxRows="3"
              [value]="dataToDiff.approval.equipment.location.address.formattedAddress"
              disabled
            ></textarea>
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.name !== dataToDiff.approval.equipment.name"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NAME' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.qrCode !== dataToDiff.approval.equipment.qrCode"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.QR_CODE' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.qrCode" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.number !== dataToDiff.approval.equipment.number"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NUMBER' | translate }}</mat-label>
            <mat-icon
              *ngIf="isExistingNumber"
              class="number-duplicated__icon"
              matTooltipClass="custom-tooltip"
              matTooltip="{{ 'APPROVALS_EQUIPMENTS.NUMBER_IN_USE' | translate }}"
              [matTooltipPosition]="'below'"
            >
              warning
            </mat-icon>
            <input
              [class.number-duplicated__input]="isExistingNumber"
              matInput
              [value]="dataToDiff.approval.equipment.number"
              disabled
            />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.type.name !== dataToDiff.approval.equipment.type.name"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.TYPE' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.type.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.archived !== dataToDiff.approval.equipment.archived"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_STATUS' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.archived" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="dataToDiff.equipment.notes !== dataToDiff.approval.equipment.notes"
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.COMMENTS' | translate }}</mat-label>
            <textarea
              matInput
              matTextareaAutosize
              matAutosizeMinRows="3"
              matAutosizeMaxRows="3"
              [value]="dataToDiff.approval.equipment.notes"
              disabled
            ></textarea>
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="
              dataToDiff.equipment.locationSector?.name !== dataToDiff.approval.equipment.locationSector?.name
            "
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_LOCATION_SECTOR' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.locationSector?.name" disabled />
          </mat-form-field>

          <mat-form-field
            floatLabel="always"
            appearance="legacy"
            [class.input-green]="
              dataToDiff.equipment.locationEnvironment?.name !== dataToDiff.approval.equipment.locationEnvironment?.name
            "
          >
            <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_LOCATION_ENVIRONMENT' | translate }}</mat-label>
            <input matInput [value]="dataToDiff.approval.equipment.locationEnvironment?.name" disabled />
          </mat-form-field>
        </div>
        <!-- MODIFIED EQUIPMENT -->
      </div>

      <div class="separator with-text mb-36" *ngIf="customFields.length">
        <span>{{ 'APPROVALS_EQUIPMENTS.DIALOG_DIFF.CUSTOM_FIELDS' | translate }}</span>
      </div>

      <div *ngFor="let customField of customFields | orderBy: 'position'">
        <div fxLayout="row" fxLayoutGap="8px" fxLayout.xs="row wrap" fxLayoutAlign="start">
          <div fxFlex="50" fxFlex.xs="100" *ngFor="let custom of customField">
            <mat-form-field
              *ngIf="custom.value && custom.name"
              floatLabel="always"
              appearance="legacy"
              [class.input-red]="custom.status === 'old' && customField[0].value !== customField[1].value"
              [class.input-green]="custom.status === 'new' && customField[0].value !== customField[1].value"
            >
              <mat-label>{{ custom.name }}</mat-label>
              <input
                matInput
                *ngIf="custom.type === 'date' || custom.type === '2'; else elseblock"
                [value]="custom.value | date: 'dd/MM/yyyy'"
                disabled
              />
              <ng-template #elseblock>
                <input matInput [value]="custom.value" disabled />
              </ng-template>
            </mat-form-field>
            <div class="field-removed" *ngIf="custom.status === 'new' && (!custom.value || !custom.name)">
              {{ 'APPROVALS_EQUIPMENTS.DIALOG_DIFF.FIELD_REMOVED' | translate }}
            </div>
            <div class="field-removed" *ngIf="custom.status === 'old' && (!custom.value || !custom.name)">
              {{ 'APPROVALS_EQUIPMENTS.DIALOG_DIFF.FIELD_ADDED' | translate }}
            </div>
          </div>
        </div>

        <div
          class="separator mb-36"
          fxShow="false"
          fxShow.xs
          *ngIf="customField[0].value && customField[0].name && customField[1].value && customField[1].name"
        ></div>
      </div>

      <div class="separator with-text mb-36" *ngIf="attachments.length">
        <span>{{ 'APPROVALS_EQUIPMENTS.DIALOG_DIFF.PHOTOS' | translate }}</span>
      </div>

      <div class="mb-36">
        <div *ngFor="let attachment of attachments | orderBy: 'createdAt'">
          <div class="attachment" fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
            <div
              fxFlex="50"
              fxFlex.xs="100"
              *ngFor="let attach of attachment"
              [hidden]="
                (attachment[0].archived && attachment[1].archived) ||
                (attach.status === 'new' && attachment[0].archived === undefined && attachment[1].archived)
              "
              [ngClass]="{
                'attachment-red':
                  (attach.status === 'old' && attachment[0].archived) ||
                  (attach.status === 'new' && !attachment[0].archived && attachment[1].archived),
                'attachment-green':
                  (attach.status === 'new' &&
                    (attachment[0].archived || attachment[0].archived === undefined) &&
                    !attachment[1].archived) ||
                  (attach.status === 'old' && !attachment[0].archived && attachment[1].archived)
              }"
            >
              <div
                fxLayout="row"
                *ngIf="attach.path"
                [ngClass]="{
                  'attachment-red':
                    attach.status === 'old' && attachment[0].title && attachment[0].title !== attachment[1].title,
                  'attachment-green':
                    attach.status === 'new' && attachment[0].title && attachment[0].title !== attachment[1].title
                }"
              >
                <div class="attachment__preview" [style.backgroundImage]="'url(' + attach.path + ')'"></div>
                <div fxLayout="column">
                  <span class="attachment__name">{{
                    attach.title || 'APPROVALS_EQUIPMENTS.DIALOG_DIFF.ATTACHMENT_WITH_EMPTY_TITLE' | translate
                  }}</span>
                  <span class="attachment__time">{{ attach.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
                  <a class="attachment__link" [href]="attach.path" target="_blank">
                    {{ 'APPROVALS_EQUIPMENTS.DIALOG_DIFF.ATTACHMENT_SHOW_ORIGINAL' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="separator mb-36"
            fxShow="false"
            fxShow.xs
            *ngIf="
              !(attachment[0].archived && attachment[1].archived) &&
              !(
                (attachment[0].status === 'new' || attachment[1].status === 'new') &&
                attachment[0].archived === undefined &&
                attachment[1].archived
              )
            "
          ></div>
        </div>
      </div>

      <div *ngIf="isExistingNumber" class="number-duplicated-message" fxLayout="row">
        <mat-icon
          class="number-duplicated-message__icon"
          matTooltip="{{ 'APPROVALS_EQUIPMENTS.NUMBER_DUPLICATED' | translate }}"
          [matTooltipPosition]="'right'"
          >warning</mat-icon
        >

        <span class="number-duplicated-message__message">
          {{ 'APPROVALS_EQUIPMENTS.NUMBER_DUPLICATED' | translate }}
        </span>
      </div>
    </form>
  </div>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <button
        [disabled]="isExistingNumber"
        class="field-background mr-16"
        mat-raised-button
        (click)="openApproveDialog()"
      >
        {{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVE_EQUIPMENT' | translate }}
      </button>

      <button color="warn" mat-raised-button (click)="openRejectDialog()">
        {{ 'APPROVALS_EQUIPMENTS.DIALOG.REJECT_EQUIPMENT' | translate }}
      </button>
    </div>
  </div>
</div>
